// extracted by mini-css-extract-plugin
module.exports = {"about":"about__lNv9D","wrap":"wrap__2eYsE","description":"description__3eWt-"};